import TabControl from './tabControl';
export default TabControl;